import { React, useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

const ReasonInput = forwardRef((props, ref) => {
  const { value, setValue, className, placeholder, type, disabled, centerPlaceholder } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
	// const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useEffect(() => {
		if (!value) applyCenterPadding();
	}, []);

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		invalidValue: () => {
			inputRef.current.style.borderColor = theme.pointRed;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.line;
		}
	}));

	function onClickInput(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function onChangeInput(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function applyCenterPadding() {
		if (!centerPlaceholder || !inputRef.current) return;
		const h = inputRef.current.clientHeight;
		const paddingTop = Math.max(6, (h - 20.27) / 2);
		inputRef.current.style.paddingTop = `${paddingTop}px`;
	}

	function resetPadding() {
		if (!centerPlaceholder || !inputRef.current) return;
		inputRef.current.style.paddingTop = '6px';
	}

	function onFocusInput(e) {
		resetPadding();
		if (changed) {
			// do nothing
		} else {
			setValue("");
		}
	}

	function onBlurInput(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
		if (!value) applyCenterPadding();
	}
  return(
    <TopLevelWrapper>
      <Input
        ref={inputRef}
        clickCount={clickCount}
        type={type}
        placeholder={defaultPlaceholder}
        value={value || ''}
        disabled={disabled}
        className={`${className} ${changed ? "changed" : ""}`}
        onClick={onClickInput}
        onChange={onChangeInput}
        onFocus={onFocusInput}
        onBlur={onBlurInput} />
    </TopLevelWrapper>
  )
})

export default ReasonInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  white-space: nowrap;
`;

const Input = styled.textarea`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  box-sizing: border-box;
  width: 100%;
  height: 100%;

  // padding: 6px 0 0 8px;
	padding: 6px 8px 6px 8px;

  background-color: ${props => props.theme.buttonFill};
  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 20.27px;

  color: ${props => props.theme.text};

  outline: none;
  resize: none;

  &::placeholder {
		font-family: NotoSansKR-Regular;
		color: ${props => props.theme.subText};
		text-align: center;
	}

  &:focus::placeholder {
    color: transparent;
  }
`;